import * as ambassadorWixIdentityInvitesV1SiteInvite from './identity-invites-v1-site-invite-site-invites.http.js';
import * as ambassadorWixIdentityInvitesV1SiteInviteTypes from './identity-invites-v1-site-invite-site-invites.types.js';
import * as ambassadorWixIdentityInvitesV1SiteInviteUniversalTypes from './identity-invites-v1-site-invite-site-invites.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function bulkInvite(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIdentityInvitesV1SiteInviteUniversalTypes.BulkSiteInviteRequest,
  ambassadorWixIdentityInvitesV1SiteInviteTypes.BulkSiteInviteRequest,
  ambassadorWixIdentityInvitesV1SiteInviteUniversalTypes.BulkSiteInviteResponse,
  ambassadorWixIdentityInvitesV1SiteInviteTypes.BulkSiteInviteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityInvitesV1SiteInvite.bulkInvite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/site-invite/bulk',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function resendInvite(): __PublicMethodMetaInfo<
  'POST',
  { inviteId: string },
  ambassadorWixIdentityInvitesV1SiteInviteUniversalTypes.ResendSiteInviteRequest,
  ambassadorWixIdentityInvitesV1SiteInviteTypes.ResendSiteInviteRequest,
  ambassadorWixIdentityInvitesV1SiteInviteUniversalTypes.SiteInviteResponse,
  ambassadorWixIdentityInvitesV1SiteInviteTypes.SiteInviteResponse
> {
  const payload = { inviteId: ':inviteId' } as any;

  const getRequestOptions =
    ambassadorWixIdentityInvitesV1SiteInvite.resendInvite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/site-invite/{inviteId}/resend',
    pathParams: { inviteId: 'inviteId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function revokeInvite(): __PublicMethodMetaInfo<
  'POST',
  { inviteId: string },
  ambassadorWixIdentityInvitesV1SiteInviteUniversalTypes.RevokeSiteInviteRequest,
  ambassadorWixIdentityInvitesV1SiteInviteTypes.RevokeSiteInviteRequest,
  ambassadorWixIdentityInvitesV1SiteInviteUniversalTypes.RevokeSiteInviteResponse,
  ambassadorWixIdentityInvitesV1SiteInviteTypes.RevokeSiteInviteResponse
> {
  const payload = { inviteId: ':inviteId' } as any;

  const getRequestOptions =
    ambassadorWixIdentityInvitesV1SiteInvite.revokeInvite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/site-invite/{inviteId}/revoke',
    pathParams: { inviteId: 'inviteId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SiteInvite as SiteInviteOriginal,
  InviteStatus as InviteStatusOriginal,
  InviteStatusWithLiterals as InviteStatusWithLiteralsOriginal,
  GetSiteInvitesRequest as GetSiteInvitesRequestOriginal,
  GetSiteInvitesResponse as GetSiteInvitesResponseOriginal,
  QuerySiteInvitesRequest as QuerySiteInvitesRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QuerySiteInvitesResponse as QuerySiteInvitesResponseOriginal,
  GetSiteInviteRequest as GetSiteInviteRequestOriginal,
  GetSiteInviteResponse as GetSiteInviteResponseOriginal,
  SiteInviteRequest as SiteInviteRequestOriginal,
  LocationRestriction as LocationRestrictionOriginal,
  SiteInviteResponse as SiteInviteResponseOriginal,
  BulkSiteInviteRequest as BulkSiteInviteRequestOriginal,
  BulkSiteInviteResponse as BulkSiteInviteResponseOriginal,
  ResendSiteInviteRequest as ResendSiteInviteRequestOriginal,
  AcceptSiteInviteRequest as AcceptSiteInviteRequestOriginal,
  AcceptSiteInviteResponse as AcceptSiteInviteResponseOriginal,
  RevokeSiteInviteRequest as RevokeSiteInviteRequestOriginal,
  RevokeSiteInviteResponse as RevokeSiteInviteResponseOriginal,
  UpdateSiteInviteRequest as UpdateSiteInviteRequestOriginal,
  UpdateSiteInviteResponse as UpdateSiteInviteResponseOriginal,
  GetContributorLimitRequest as GetContributorLimitRequestOriginal,
  GetContributorLimitResponse as GetContributorLimitResponseOriginal,
  ContributorLimitation as ContributorLimitationOriginal,
  ParseSiteInviteTokenRequest as ParseSiteInviteTokenRequestOriginal,
  ParseSiteInviteTokenResponse as ParseSiteInviteTokenResponseOriginal,
} from './identity-invites-v1-site-invite-site-invites.types.js';
